module.exports = {//例子 this.$i18n.t('main.submit_audit')  {{$t('main.status_name')}}

    main:{
        chef              :'Gordon Ramsay',
        brand             :'Michelin',
        contact           :'Contact Info',
        manager           :'Resturant Manager',
        menu              :'Menu',
        course_menu       :'course menu',
        pax               :'pax',
        gallery           :'Gallery',
        
    }

}